import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { journeyRadioIllustrationColors as colors } from './constants';
import { JourneyRadioIllustrationColors } from './types';

export const EventEntrySource = ({
  height = 80,
  width = 80,
  backgroundColor = colors.backgroundColor,
  lineColor = colors.lineColor,
  fillColor = colors.fillColor,
}: SvgIconProps & JourneyRadioIllustrationColors) => (
  <SvgIcon width={width} height={height} viewBox="0 0 80 80" fill="none">
    <g clipPath="url(#clip0_3878_67022)">
      <path
        d="M8 40C8 48.4869 11.3714 56.6263 17.3726 62.6274C23.3737 68.6286 31.5131 72 40 72C48.4869 72 56.6263 68.6286 62.6274 62.6274C68.6286 56.6263 72 48.4869 72 40C72 31.5131 68.6286 23.3737 62.6274 17.3726C56.6263 11.3714 48.4869 8 40 8C31.5131 8 23.3737 11.3714 17.3726 17.3726C11.3714 23.3737 8 31.5131 8 40Z"
        fill={backgroundColor}
      />
      <path
        d="M58.0295 23.7644C57.2361 24.2791 56.3974 24.7204 55.5239 25.0828C44.6263 29.6092 41.8191 20.0956 30.9215 24.622C28.926 25.4773 27.1024 26.6876 25.5391 28.194"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.4605 29.6208C59.6676 30.135 58.8295 30.5758 57.9565 30.9376C47.0589 35.464 44.2509 25.9504 33.3533 30.48C31.358 31.3354 29.5345 32.546 27.9717 34.0528"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.8931 35.4761C62.1001 35.9903 61.262 36.4313 60.3891 36.7937C49.4915 41.3201 46.6843 31.8065 35.7859 36.3329C33.7907 37.1882 31.9673 38.3985 30.4043 39.9049"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0293 20.0674L38.2181 42.1882"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.4258 18.9365L44.3442 40.4061"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1729 21.0586L52.0913 42.529"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3799 21.8789L59.2975 43.3493"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.6515 20.448C56.588 20.2956 56.4932 20.1583 56.3733 20.045C56.2533 19.9317 56.1108 19.8449 55.955 19.7902C55.7993 19.7356 55.6338 19.7144 55.4693 19.7279C55.3048 19.7414 55.145 19.7895 55.0003 19.8688C54.5568 20.1131 54.1004 20.3332 53.6331 20.528C42.7355 25.0552 39.9275 15.5408 29.0299 20.0672C27.0346 20.9228 25.211 22.1331 23.6475 23.6392L32.8363 45.76C34.3995 44.2533 36.2232 43.0428 38.2187 42.1872C49.1163 37.6608 51.9235 47.1744 62.8219 42.648C63.3757 42.4161 63.9142 42.1489 64.4339 41.848C64.6815 41.706 64.8687 41.4785 64.9605 41.2082C65.0522 40.9379 65.0422 40.6434 64.9323 40.38L56.6515 20.448Z"
        fill="white"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0294 20.0674L30.9214 24.6218C28.9242 25.4749 27.1006 26.6875 25.5414 28.1994L23.6494 23.645C25.2087 22.1333 27.0323 20.9207 29.0294 20.0674Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1204 20.928L45.0124 25.4824C42.5052 24.6624 40.1724 23.5264 37.2764 23.3864L35.3828 18.832C38.2788 18.972 40.6124 20.108 43.1204 20.928Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.9979 19.867C55.1426 19.7871 55.3026 19.7386 55.4674 19.7248C55.6321 19.711 55.7979 19.7321 55.9539 19.7868C56.1099 19.8415 56.2526 19.9285 56.3727 20.0421C56.4928 20.1557 56.5875 20.2934 56.6507 20.4462L58.0299 23.767C57.2363 24.2804 56.3977 24.7206 55.5243 25.0822C54.435 25.5446 53.2992 25.8884 52.1363 26.1078L50.2451 21.5534C51.4079 21.3338 52.5438 20.9899 53.6331 20.5278C54.1 20.333 54.5556 20.1124 54.9979 19.867Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2747 23.386L39.7067 29.242C37.5223 29.1639 35.3491 29.5873 33.3539 30.4796L30.9219 24.6244C32.9171 23.7318 35.0903 23.3081 37.2747 23.386Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.1363 26.108L54.5691 31.964C52.1807 32.3976 49.7197 32.1813 47.4435 31.3376L45.0107 25.4824C47.287 26.3257 49.748 26.5418 52.1363 26.108Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.3536 30.4805L35.7856 36.3365C33.7887 37.1898 31.9655 38.4024 30.4064 39.9141L27.9736 34.0581C29.5328 32.5462 31.3564 31.3335 33.3536 30.4805Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4399 31.3374L49.8719 37.1934C47.3647 36.3734 45.0311 35.2374 42.1351 35.0974L39.7031 29.2422C42.6023 29.3822 44.9351 30.5182 47.4399 31.3374Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.4612 29.6221L62.894 35.4781C62.1003 35.9914 61.2616 36.4316 60.3884 36.7933C59.2989 37.2552 58.1631 37.599 57.0004 37.8189L54.5684 31.9637C55.7311 31.7434 56.8669 31.3993 57.9564 30.9373C58.8296 30.576 59.668 30.1358 60.4612 29.6221Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.138 35.0972L44.5708 40.9524C42.3866 40.8739 40.2136 41.2965 38.218 42.1876L35.7852 36.3324C37.7807 35.441 39.9538 35.0184 42.138 35.0972Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.0006 37.819L59.4326 43.6742C57.0443 44.1079 54.5832 43.8918 52.307 43.0486L49.875 37.1934C52.1512 38.0367 54.6123 38.2528 57.0006 37.819Z"
        fill={fillColor}
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.146 65.7654C41.3257 66.1967 41.3265 66.6817 41.1485 67.1138C40.9705 67.5458 40.6282 67.8894 40.1968 68.069C39.7655 68.2486 39.2805 68.2495 38.8485 68.0715C38.4165 67.8935 38.0729 67.5511 37.8932 67.1198L19.786 23.5254C19.6069 23.0938 19.6065 22.6087 19.7849 22.1769C19.9634 21.745 20.3061 21.4017 20.7376 21.2226C21.1692 21.0434 21.6543 21.043 22.0861 21.2214C22.518 21.3999 22.8613 21.7426 23.0404 22.1742L41.146 65.7654Z"
        fill="white"
        stroke={lineColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3878_67022">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
